<template>
  <order-list :is-order-status="20"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'Shipped',
  components: {
    OrderList
  }
}
</script>
